import React, { Component } from 'react';

class Separator extends Component {
  render() {
    return <div className="layout-grid-separator" />;
  }
}

export default Separator;
